import { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import apiUrl from '../../configs/constant';
import axios from 'axios'
import { useToast } from "../ToastProvider";
interface Props {
    open: boolean
    onClose: () => void
}

export default function DialogSaldoAwalHutang({
    open,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [listSupplier, setListSupplier] = useState<any[]>([])

    const today = new Date();
    const tglToday = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    
    const getSupplier = () => {
        setListSupplier([])
        let url = apiUrl.apiUrl + '/purchasing/supplier/list-combo'

        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSupplier(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    useEffect(() => {
        if (!open) return
        reset();
        getSupplier();
    }, [open])

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            pbsupplier_id: null,
            tgl: tglToday,
            kode: null,
            total: null,
            keterangan: null,
        }
    })

    const onSubmit = (payload: any) => {
        const payloadFinal = {
            ...payload,
            pbsupplier_id: payload.pbsupplier_id?.id || null,
        };

        const url = apiUrl.apiUrl + '/acc/saldo-awal/add-hutang';
        axios.post(url, payloadFinal, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success');
            onClose();
        });
    };

    const formatNumber = (value: string | number) => {
        if (!value) return "";

        const str = String(value);

        // split decimal
        const [int, dec] = str.replace(/\./g, "").split(",");

        const formattedInt = Number(int || 0).toLocaleString("id-ID");

        return dec !== undefined ? `${formattedInt},${dec}` : formattedInt;
    };

    const parseNumber = (value: string) => {
        return value.replace(/\./g, "");
    };

    const filterSupplier = (options: any[], { inputValue }: any) => {
        const keywords = inputValue
            .toLowerCase()
            .trim()
            .split(/\s+/)
            .filter(Boolean);

        return options.filter((option) => {
            const text = `${option.nama || ""}`.toLowerCase();

            return keywords.every((keyword: string) =>
                text.includes(keyword)
            );
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle sx={{ textAlign: 'center' }}>
                    SALDO AWAL HUTANG
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {/* Tanggal */}
                        <Grid item xs={12}>
                            <Controller
                                name="tgl"
                                control={control}
                                defaultValue={new Date().toISOString().slice(0, 10)}
                                rules={{ required: "Tanggal wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="Tanggal"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!errors.tgl}
                                        helperText={errors.tgl?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="pbsupplier_id"
                                control={control}
                                rules={{ required: "Supplier wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        options={listSupplier}
                                        value={field.value || null}
                                        onChange={(_, val) => field.onChange(val)}
                                        isOptionEqualToValue={(opt, val) =>
                                            opt.id === val?.id
                                        }
                                        getOptionLabel={(o) => o?.nama ?? ""}
                                        filterOptions={filterSupplier}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Supplier"
                                                placeholder="Cari nama supplier..."
                                                error={!!errors.pbsupplier_id}
                                                helperText={
                                                    errors.pbsupplier_id?.message as string
                                                }
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="kode"
                                control={control}
                                rules={{ required: "Kode wajib dipilih" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Kode"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        error={!!errors.kode}
                                        helperText={errors.kode?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                        {/* TOTAL */}
                        <Grid item xs={12}>
                            <Controller
                                name="total"
                                control={control}
                                rules={{
                                    required: "Total wajib diisi",
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Total"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.total}
                                        helperText={errors.total?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* KETERANGAN */}
                        <Grid item xs={12}>
                            <Controller
                                name="keterangan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Keterangan"
                                        fullWidth
                                        multiline
                                        rows={3}
                                        error={!!errors.keterangan}
                                        helperText={errors.keterangan?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        SIMPAN
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}